import { Component, OnInit } from '@angular/core';
import {HssResponse} from '../../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../../services/rest-api/info.api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-deptstaff',
  templateUrl: './deptstaff.component.html',
  styleUrls: ['./deptstaff.component.scss']
})
export class DeptstaffComponent implements OnInit {

  deptStaffData: any[] = [];
  public deptId: number = 0;
  loader: boolean = false;
  divRepat: any[] = [1,2,3,4,5,6];

  constructor(
    private _info: InfoApiService,
    private _actRoute: ActivatedRoute,
    private router: Router,
    private seo: SeoService
  ) {
    this._actRoute.paramMap.subscribe(params => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    // this.deptId = Number(localStorage.getItem('currentDeptId'));
    this.deptId = this._actRoute.snapshot.params.id;
    this.getStaffByDept(this.deptId);

    this.seo.setMeta('Staff members of the Faculty of Humanities & Social Sciences');
  }

  // View staff by category id for department
  getStaffByDept(deptId: number){
    this.loader = true;
    this._info.getStaffByDeptByCat(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.deptStaffData = response.body;
        this.loader = false;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
}
